import type { CreateContactBody } from '../../hooks/useContacts';

const OPTIONAL_TEXT_FIELDS = [
  'email',
  'phone',
  'title',
  'company',
  'notes',
] as const;

function cleanText(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

export function buildCreateContactPayload(
  form: CreateContactBody,
): CreateContactBody {
  const body: CreateContactBody = {
    ...form,
    firstName: form.firstName.trim(),
    lastName: form.lastName.trim(),
  };

  for (const field of OPTIONAL_TEXT_FIELDS) {
    const value = cleanText(body[field]);
    if (value) body[field] = value;
    else delete body[field];
  }

  if (!body.clientId) {
    delete body.clientId;
  }

  return body;
}
